import YouTubePlayer from 'youtube-player'

export default function YoutubeBg () {
  const IFRAME_IMAGE_BUTTONS = document.querySelectorAll('.text-image-banner .iframe-container-button')
  if (IFRAME_IMAGE_BUTTONS.length > 0) {
    for (let i = 0; i < IFRAME_IMAGE_BUTTONS.length; i++) {
      const BUTTON = IFRAME_IMAGE_BUTTONS[i]
      const YT_ID = BUTTON.getAttribute('data-yt-id')
      const IFRAME = BUTTON.parentNode.parentNode.querySelector('.iframe-container iframe')
      const PLAYER_CONTAINER = BUTTON.parentNode.parentNode.querySelector('.iframe-container-player')
      const PLAYER = YouTubePlayer(PLAYER_CONTAINER, {
        videoId: YT_ID
      })

      BUTTON.addEventListener('click', () => {
        const PARENT = BUTTON.parentNode
        PARENT.parentNode.removeChild(PARENT)
        IFRAME.parentNode.removeChild(IFRAME)
        PLAYER.playVideo()
      })
    }
  }
}